import { f as a } from "./index758.mjs";
import { g as e } from "./index767.mjs";
var o = a, p = e, g = p.RegExp, i = o(function() {
  var r = g("(?<a>b)", "g");
  return r.exec("b").groups.a !== "b" || "b".replace(r, "$<a>c") !== "bc";
});
export {
  i as r
};
